import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <img src="https://cdn.abacus.ai/images/ce62aaea-7192-4eab-8134-3539efec6757.png" alt="GiftBox Logo" className="w-10 h-10 rounded-lg object-cover" />
            <div>
              <h1 className="text-xl font-bold text-gray-800">GiftBox</h1>
              <p className="text-sm text-gray-500">Política de Tratamiento de Datos</p>
            </div>
          </div>
          <Link to="/" className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition">
            ← Volver a la Tienda
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">Política de Tratamiento de Datos Personales</h1>
            <p className="text-gray-600">Última actualización: {new Date().toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>

          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Identificación del Responsable</h2>
              <div className="text-gray-600">
                <p className="mb-2"><strong>Nombre del responsable:</strong> GiftBox</p>
                <p className="mb-2"><strong>Dirección:</strong> Bogotá, Colombia</p>
                <p className="mb-2"><strong>Email de contacto:</strong> hola@giftbox.co</p>
                <p className="mb-2"><strong>Teléfono:</strong> 300 123 4567</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Fundamento Legal</h2>
              <p className="text-gray-600 mb-4">
                Esta política se elabora en cumplimiento de la Ley 1581 de 2012 de Protección de Datos Personales 
                y el Decreto Reglamentario 1377 de 2013 en Colombia, estableciendo los parámetros para el 
                tratamiento de datos personales recolectados por GiftBox.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Definiciones</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>Authorization:</strong> Consentimiento previo, expreso e informado del Titular para llevar a cabo 
                  el tratamiento de datos personales.
                </p>
                <p>
                  <strong>Database:</strong> Conjunto organizado de datos personales que sea objeto de tratamiento.
                </p>
                <p>
                  <strong>Personal Data:</strong> Cualquier información vinculada o que pueda asociarse a una o varias 
                  personas naturales determinadas o determinables.
                </p>
                <p>
                  <strong>Treatment:</strong> Cualquier operación o conjunto de operaciones sobre datos personales.
                </p>
                <p>
                  <strong>TITULAR:</strong> Persona natural cuyos datos personales sean objeto de tratamiento.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Datos Personales Recopilados</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>4.1 Datos de Identificación:</strong> Nombres completos, número de identificación, 
                  dirección de correo electrónico, número telefónico, dirección de residencia.
                </p>
                <p>
                  <strong>4.2 Datos de Transacción:</strong> Información relacionada con pedidos, productos 
                  adquiridos, historial de compras, preferencias de productos.
                </p>
                <p>
                  <strong>4.3 Datos de Navegación:</strong> Dirección IP, cookies, historial de navegación en nuestro 
                  sitio web, información sobre el dispositivo utilizado.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Finalidad del Tratamiento</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>5.1 Finalidades Comerciales:</strong>
                </p>
                <ul className="list-disc list-inside ml-6 space-y-2">
                  <li>Procesar y gestionar pedidos de productos</li>
                  <li>Coordinar entregas y envíos</li>
                  <li>Gestionar pagos y facturación</li>
                  <li>Ofrecer productos y servicios relacionados</li>
                  <li>Enviar información promocional y comercial (con autorización previa)</li>
                </ul>
                <p>
                  <strong>5.2 Finalidades Operativas:</strong>
                </p>
                <ul className="list-disc list-inside ml-6 space-y-2">
                  <li>Mejorar nuestros productos y servicios</li>
                  <li>Realizar análisis estadísticos y de mercado</li>
                  <li>Prevenir fraudes y garantizar la seguridad</li>
                  <li>Cumplir con obligaciones legales y regulatorias</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Autorización y Consentimiento</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  <strong>6.1 Manifestación de Consentimiento:</strong> El Titular manifiesta su autorización 
                  expresa mediante la aceptación de esta política y el marcado de la casilla de verificación 
                  durante el proceso de registro o compra.
                </p>
                <p>
                  <strong>6.2 Revocación de la Autorización:</strong> El Titular puede revocar la autorización 
                  en cualquier momento enviando un correo electrónico a hola@giftbox.co con el asunto 
                  "Revocación de autorización de tratamiento de datos".
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Derechos del Titular</h2>
              <div className="space-y-4 text-gray-600">
                <p>Como titular de datos personales, usted tiene derecho a:</p>
                <ul className="list-disc list-inside ml-6 space-y-2">
                  <li><strong>Conocer:</strong> Acceder gratuitamente a sus datos personales que han sido objeto de tratamiento.</li>
                  <li><strong>Actualizar:</strong> Solicitar la corrección de sus datos personales cuando sean inexactos.</li>
                  <li><strong>Rectificar:</strong> Solicitar la eliminación de datos cuando considere que no son relevantes.</li>
                  <li><strong>Revocar:</strong> Retirar su autorización para el tratamiento de sus datos personales.</li>
                  <li><strong>Consultar:</strong> Informarse sobre el uso que se ha dado a sus datos personales.</li>
                  <li><strong>Reclamar:</strong> Presentar reclamaciones ante la Superintendencia de Industria y Comercio.</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. Seguridad de la Información</h2>
              <p className="text-gray-600 mb-4">
                GiftBox implementa medidas de seguridad técnicas, humanas y administrativas adecuadas para proteger 
                los datos personales contra acceso no autorizado, pérdida, modificación o destrucción. Utilizamos 
                cifrado SSL para todas las transmisiones de datos y mantenemos servidores seguros.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Transferencia Internacional de Datos</h2>
              <p className="text-gray-600 mb-4">
                GiftBox no realizará transferencias internacionales de datos personales sin la autorización previa 
                y expresa del Titular, salvo en los casos requeridos por ley.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Cambios a esta Política</h2>
              <p className="text-gray-600 mb-4">
                Nos reservamos el derecho de modificar esta política en cualquier momento. Cualquier cambio será 
                notificado a través de nuestro sitio web y, cuando sea aplicable, por correo electrónico.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">11. Vigencia</h2>
              <p className="text-gray-600 mb-4">
                Esta política entra en vigor a partir del {new Date().toLocaleDateString('es-CO')} y permanecerá 
                vigente mientras GiftBox realice tratamiento de datos personales.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">12. Contacto para Asuntos de Privacidad</h2>
              <div className="text-gray-600">
                <p className="mb-2">Para ejercer sus derechos o realizar consultas sobre esta política:</p>
                <p><strong>Email:</strong> dataprotection@giftbox.co</p>
                <p><strong>Teléfono:</strong> 300 123 4567</p>
                <p><strong>Dirección:</strong> Bogotá, Colombia</p>
                <p className="mt-4">
                  <strong>Atención a reclamos:</strong> Si considera que sus derechos han sido vulnerados, 
                  puede presentar una reclamación ante la Superintendencia de Industria y Comercio.
                </p>
              </div>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t">
            <p className="text-sm text-gray-500 text-center">
              © 2026 GiftBox. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Privacy;